// extracted by mini-css-extract-plugin
module.exports = {"downloadIcon":"DataResource_downloadIcon__3lvtJ"};